module.exports = {"330603001":"柯桥街道","330603002":"柯岩街道","330603003":"华舍街道","330603004":"湖塘街道","330603005":"齐贤街道","330603006":"福全街道","330603007":"安昌街道","330603008":"兰亭街道","330603009":"钱清街道","330603010":"杨汛桥街道","330603011":"马鞍街道","330603105":"平水镇","330603107":"王坛镇","330603109":"稽东镇","330603111":"漓渚镇","330603114":"夏履镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330603.json
// module id = 1095
// module chunks = 0